var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VContainer',{attrs:{"grid-list-lg":"","fill-height":"","fluid":""}},[(_vm.$isUserStudent)?_c('Submit',{attrs:{"model":"standalone"}}):_c('Save')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }